namespace TabAurous.OMS {
    export interface RewardsDetailsForm {
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: Serenity.LookupEditor;
        SubCategoryId: Serenity.LookupEditor;
        PurchaseValue: Serenity.DecimalEditor;
        PurchasePoints: Serenity.IntegerEditor;
    }

    export class RewardsDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.RewardsDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RewardsDetailsForm.init)  {
                RewardsDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.IntegerEditor;

                Q.initFormType(RewardsDetailsForm, [
                    'ProductTypeId', w0,
                    'CategoryId', w0,
                    'SubCategoryId', w0,
                    'PurchaseValue', w1,
                    'PurchasePoints', w2
                ]);
            }
        }
    }
}
